import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog9.css';
import blogImage from '../Asets/Blog.jpg';
import blog99 from '../Asets/blog99.png';
import Header from '../components/header';
import Footer from '../components/footer';

const Blog9 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Home to School: Road Safety Tips for Children | Red School House Vadodara
          </h2>
          <br />
          <div className="published-badge">Published on: 01 October 2025</div>
          <br />

          <img
            src={blog99}
            alt="Home to School - Road Safety Tips"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              Every parent knows that sending their little one to school is a moment filled with pride,
              joy, and a little bit of worry. At <strong>Red School House Vadodara</strong>, we understand that
              a child’s journey is not just about learning in the classroom but also about staying safe
              outside of it—especially on the road.
            </p>

            <p>
              Young children are naturally curious and sometimes impulsive, which is why teaching them road safety
              habits early on is so important. By practicing simple rules every day, children can build safe habits
              that will stay with them for life. Here are some practical and easy-to-follow road safety tips for
              children that parents can introduce during daily routines:
            </p>

            <h3>1. Understanding Traffic Lights</h3>
            <p>
              Start with the basics:
            </p>
            <ul>
              <li><strong>Red</strong> — Stop</li>
              <li><strong>Green</strong> — Go</li>
              <li><strong>Yellow</strong> — Get Ready</li>
            </ul>
            <p>
              Teaching children what these colors mean makes them more alert and confident while crossing roads.
            </p>

            <h3>2. Walk on the Footpath</h3>
            <p>
              Children should always use the footpath and avoid walking in the middle of the road. If there is no
              footpath, walking on the side facing traffic helps them stay more visible to drivers.
            </p>

            <h3>3. Cross with Care — "Stop • Look • Listen • Think"</h3>
            <p>Teach your child the simple rule before crossing:</p>
            <ul>
              <li>Stop at the edge of the road</li>
              <li>Look both ways carefully</li>
              <li>Listen for approaching vehicles</li>
              <li>Think before stepping forward</li>
            </ul>
            <p>This habit builds patience and awareness.</p>

            <h3>4. School Bus Safety</h3>
            <p>If your child travels by bus, remind them to:</p>
            <ul>
              <li>Stand in a queue while boarding</li>
              <li>Never push or rush inside</li>
              <li>Sit properly during the ride</li>
              <li>Wait for the bus to stop completely before getting down</li>
            </ul>

            <h3>5. Walk with an Adult</h3>
            <p>
              Younger children should always hold hands with parents or guardians while walking near busy roads.
              This simple step prevents accidents and helps children learn road awareness from caregivers.
            </p>

            <h3>6. Be Seen, Stay Safe</h3>
            <p>
              Bright-colored clothes or reflective bags make children more visible to drivers, especially in low light.
              This small choice can make a big difference.
            </p>

            <h3>Why Road Safety Matters</h3>
            <p>
              At <strong>Red School House Vadodara</strong>, we believe education goes beyond books. Our role is to nurture
              children into responsible, confident, and caring individuals. Through playful activities, stories, and
              role-plays, we introduce them to safety habits in ways they can easily understand.
            </p>

            <h3>About Red School House Vadodara</h3>
            <p>
              Every day at Red School House Vadodara is an opportunity to spark curiosity and joy. Widely regarded as the
              Best Nursery School in Vadodara, we focus on learning through play, stories, and hands-on experiences. With
              small class sizes and caring teachers, we provide a safe and nurturing environment where children thrive
              academically, socially, and emotionally.
            </p>

            <p><strong>Ready to take the next step?</strong> Schedule a tour with us today!</p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog9;
